import { useStateContext } from '../../context.tsx';
import { Degree } from '../Resume/Education.tsx';
import { For, Show } from 'solid-js';
import './educationdescription.scss';
import { dateToString } from '../../Utility/utility.tsx';

export function EducationDescription() {
    let state = useStateContext();
    return (
        <Show when={(state.selectedEntity() as any).degrees}>
            <div class="edu-card">
                <h2 class="edu-institution">{(state.selectedEntity() as any).degrees[0].institution}</h2>
                <img class="edu-logo" src={(state.selectedEntity() as any).degrees[0].logoImg} alt="University Logo"></img>
                <div class="degrees">
                <For each={(state.selectedEntity() as any).degrees}>
                    {(degree: Degree) => {
                        return (
                            <div class="degree">
                                <h3 class="degree-title">{degree.degree}</h3>
                                <h4 class="degree-date">{dateToString(degree.start)} - {dateToString(degree.end) == dateToString(new Date()) ? "Present" : dateToString(degree.end)}</h4>
                                <div class="degree-highlights">
                                    <For each={degree.highlights}>
                                        {(highlight: string) => {
                                            return (
                                                <>
                                                    <span class="degree-hightlight">◉ {highlight}</span>
                                                    <br></br>
                                                </>
                                            )
                                        }}
                                    </For>
                                </div>
                                <p></p>
                            </div>
                        )
                    }}
                </For>
                </div>
            </div>
        </Show>
    );
}
